import { useMemo } from "react";
import { CircularProgress } from "@mui/material";
import { useGetSomeIngredientReferencesUnified } from "src/api/client-api/ingredientReferenceUnified/useGetSomeIngredientReferencesUnified";

type IngredientReferenceFilterChipValueProps = {
    compositeIds: string[];
};

export const IngredientReferenceFilterChipValue = (props: IngredientReferenceFilterChipValueProps) => {
    const { compositeIds } = props;
    const { ingredientReferences, isLoading } = useGetSomeIngredientReferencesUnified(compositeIds);

    const labels = useMemo(() => {
        const nameByCompositeId = new Map((ingredientReferences ?? []).map((ref) => [ref.compositeId, ref.name]));
        return compositeIds.map((id) => nameByCompositeId.get(id) ?? id);
    }, [ingredientReferences, compositeIds]);

    if (isLoading) return <CircularProgress size="12px" />;

    return <>{labels.join(", ")}</>;
};
